import { attr, belongsTo } from '@ember-data/model';
import ShModel from './sh-model';

class BlastUser extends ShModel {
  @attr('number') userRating;
  @attr('number') userCompensationMin;
  @attr('number') userUnavailableDateRangeMin;
  @attr('number') userUnavailableDateRangeMax;
  @attr('boolean') userWasBlasted;
  @attr('boolean') userRateFilterFailed;
  @attr('boolean') userAvailabilityFilterFailed;
  @attr('boolean') userEmailUnsubscribedFilterFailed;
  @attr('boolean') userNotificationOptOutFilterFailed;

  //Relationships
  @belongsTo('user', { async: false, inverse: null }) user;
}

export default BlastUser;

